import controller from './wf-editor.controller';
import template from './wf-editor.html';

export default {
	controller,
	template,
	bindings: {
		adminWf: '<',
		tab:     '<designer',
	},
};
